<template>
    <div class="vrm-form__fieldset-item vrm-form__fieldset-item--checkbox">
        <label class="sg-textfield-label">
            <span class="sg-textfield-label-caption">
                {{ title }}
            </span>
        </label>
        <div
            class="vrm-form__custom-radio-checkbox"
            :class="{ 'vrm-form__custom-radio-checkbox--inline': inline }"
        >
            <div
                v-for="option in options"
                :key="option.value"
                class="sg-custom-check-and-radio custom-radio "
                :class="{ active: value === option.value }"
            >
                <label>
                    <input v-model="value" :value="option.value" type="radio" />
                    <span class="sg-caption" v-html="option.name"></span>
                    <div class="sg-alternative-display">
                        <div class="sg-outer">
                            <div class="sg-inner"></div>
                        </div>
                    </div>
                </label>
                <InputError v-show="hasError"></InputError>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import InputError from '@/vue/components/forms/InputError.vue';

@Component({
    components: { InputError },
})
@AngularLocaleBundle('form')
export default class VrmOptionField extends Vue {
    @Prop({ type: String, required: true })
    title;

    @Prop({ type: Boolean, default: false })
    required;

    @Prop({ type: Boolean, default: true })
    inline;

    @Prop({ type: Array, default: () => [] })
    options;

    @Model('input')
    model;

    valuePostedThisTick = false;
    touched = false;
    hasError = false;

    get value() {
        return this.model;
    }

    set value(newValue) {
        this.valuePostedThisTick = true;
        this.$emit('input', newValue);
        this.$nextTick(() => {
            this.valuePostedThisTick = false;
        });
    }

    vrmValidate() {
        this.touched = true;
        this.hasError = false;
        const value = this.valuePostedThisTick ? this.$refs.input.value : this.value;
        if (this.required && !this.options.find(o => o.value === value)) {
            this.hasError = true;
            return false;
        }
        return true;
    }
}
</script>
